<script>
    /** Muestra el indicador cuando es true. */
    export let loading = false
    /** Tamaño visual: `sm` | `md` | `lg`. */
    export let size = 'md'
    /** Texto visible y para lectores de pantalla. */
    export let label = 'Cargando información'
    /** Menos altura vertical (tablas, gráficas). */
    export let compact = false

    const letters = ['T', 'I', 'L']
</script>

{#if loading}
    <div
        class="til-spinner"
        class:til-spinner--compact={compact}
        class:til-spinner--sm={size === 'sm'}
        class:til-spinner--lg={size === 'lg'}
        role="status"
        aria-live="polite"
        aria-busy="true"
    >
        <div class="til-spinner__stack">
            <span class="til-spinner__word" aria-hidden="true">
                {#each letters as letter, index}
                    <span
                        class="til-spinner__letter"
                        style="--til-spinner-delay: {index * 0.14}s"
                    >{letter}</span>
                {/each}
            </span>
            <p class="til-spinner__caption">{label}</p>
        </div>
    </div>
{/if}

<style lang="scss">
    .til-spinner {
        --til-spinner-letter-size: 2.5rem;
        --til-spinner-gap: 0.16em;
        --til-spinner-cycle: 1.05s;

        display: flex;
        align-items: center;
        justify-content: center;
        min-height: 7.5rem;
        padding: 2rem 1rem;
        animation: til-spinner-enter 0.2s ease-out;
    }

    .til-spinner--compact {
        min-height: 4.5rem;
        padding: 1.25rem 0.5rem;
    }

    .til-spinner--sm {
        --til-spinner-letter-size: 1.75rem;
        --til-spinner-gap: 0.14em;
        --til-spinner-cycle: 0.95s;
    }

    .til-spinner--lg {
        --til-spinner-letter-size: 3.25rem;
        --til-spinner-gap: 0.18em;
        --til-spinner-cycle: 1.15s;
    }

    .til-spinner__stack {
        display: flex;
        flex-direction: column;
        align-items: center;
        gap: 0.875rem;
        text-align: center;
    }

    .til-spinner--compact .til-spinner__stack {
        gap: 0.625rem;
    }

    .til-spinner__word {
        display: inline-flex;
        align-items: flex-end;
        gap: var(--til-spinner-gap);
        line-height: 1;
        user-select: none;
    }

    .til-spinner__caption {
        margin: 0;
        max-width: 16rem;
        font-size: 0.9375rem;
        font-weight: 500;
        line-height: 1.4;
        color: var(--til-muted, #6b7280);
    }

    .til-spinner--sm .til-spinner__caption {
        font-size: 0.8125rem;
    }

    .til-spinner--lg .til-spinner__caption {
        font-size: 1.0625rem;
    }

    .til-spinner__letter {
        display: inline-block;
        font-family: inherit;
        font-size: var(--til-spinner-letter-size);
        font-weight: 800;
        letter-spacing: 0.04em;
        color: var(--til-muted, #9ca3af);
        animation: til-spinner-letter var(--til-spinner-cycle) ease-in-out infinite;
        animation-delay: var(--til-spinner-delay, 0s);
        will-change: transform, opacity, color;
    }

    @keyframes til-spinner-letter {
        0%,
        55%,
        100% {
            opacity: 0.4;
            transform: translateY(0) scale(1);
            color: var(--til-muted, #9ca3af);
        }

        28% {
            opacity: 1;
            transform: translateY(-0.22em) scale(1.06);
            color: var(--til-dark, #fbbf24);
        }
    }

    @keyframes til-spinner-enter {
        from {
            opacity: 0;
            transform: translateY(4px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    @media (prefers-reduced-motion: reduce) {
        .til-spinner {
            animation: none;
        }

        .til-spinner__letter {
            animation-name: til-spinner-letter-reduced;
            animation-duration: 1.4s;
        }
    }

    @keyframes til-spinner-letter-reduced {
        0%,
        55%,
        100% {
            opacity: 0.45;
            color: var(--til-muted, #9ca3af);
        }

        28% {
            opacity: 1;
            color: var(--til-dark, #fbbf24);
        }
    }
</style>
